import Vue from 'vue'
import VueI18n from 'vue-i18n'
import vueResource from 'vue-resource'
import store from '@/store'
import { localeEnv } from './utils'

Vue.use(VueI18n)

const messages = {}

const i18n = new VueI18n({
  locale: localeEnv,
  messages
})

const langUrl = `lang/${localeEnv}.json`

Vue.use(vueResource)
Vue.http.get(langUrl).then(msg => {
  i18n.setLocaleMessage(localeEnv, msg.body)
  store.langLoaded = true
})

export default i18n



// WEBPACK FOOTER //
// ./src/lang/index.js